import { Alert } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

export function RemoveInvoiceDiscountDialog({
  pending,
  error,
  onClose,
  onSubmit,
}: {
  pending: boolean
  error: boolean
  onClose: () => void
  onSubmit: () => void
}) {
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Remove Discount Code?</DialogTitle>
          <DialogDescription className="sr-only">Remove Discount Code</DialogDescription>
        </DialogHeader>
        {error && <Alert>The Discount Code could not be removed</Alert>}
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose} disabled={pending}>
            Keep Discount Code
          </Button>
          <Button type="button" variant="destructive" onClick={onSubmit} disabled={pending}>
            Remove Discount Code
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
